import { createFeatureSelector } from '@ngrx/store';

import { AppState } from '@core/domain/state/core.state';

export * from './market.actions';
export * from './market.state';
export * from './market.effects';
export * from './market.selectors';

export const getSeoState = createFeatureSelector<AppState>('market');
